<template>
  <div class="dm-nav-bar dm-header">
    <header>
      <div class="clearfix">
        <span class="dm-nav-left dm-nav-btn"
          @click="$emit('handle-left')">
          <slot name="left">
            <i class="dm-icon iconfont icon-angle-single-left"
              v-if="back"
              @click="$router.go(-1)"></i>
            {{leftText}}
          </slot>
        </span>

        <span class="dm-nav-mid">
          <slot name="title">
            {{title}}
          </slot>
        </span>

        <span class="dm-nav-right dm-nav-btn"
          @click="$emit('handle-right')">
          <slot name="right">
            {{rightText}}
          </slot>
        </span>
      </div>
    </header>
  </div>
</template>

<script>
import './index.less'

export default {
  props: {
    title: String,
    leftText: String,
    rightText: String,
    back: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DyHeader/index.vue